import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export default function VideoPlayerIcon(props: SvgIconProps) {
    return (
        <SvgIcon {...props}>
            <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.8" fill-rule="evenodd" clip-rule="evenodd" d="M9.16657 18.3333C4.11217 18.3333 0 14.2212 0 9.16657C0 4.11217 4.11217 0 9.16657 0C14.221 0 18.3331 4.11217 18.3331 9.16657C18.3331 14.2212 14.221 18.3333 9.16657 18.3333Z" fill="black"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M12.1607 8.57329C12.6951 8.89779 12.6951 9.67344 12.1607 9.99794L7.93306 12.5647C7.37771 12.9019 6.66724 12.5021 6.66724 11.8524L6.66724 6.71885C6.66724 6.06915 7.37771 5.66935 7.93306 6.00653L12.1607 8.57329Z" fill="white"/>
            </svg>
        </SvgIcon>
    );
}